import { useRef,useState,  useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Badge } from '../components/badge'
import { Fragment } from "react/jsx-runtime";
import { SidebarLayoutNew } from "../components/sidebar-layout-new";  
import { Heading, Subheading } from '../components/heading' 
import { EyeIcon } from "@heroicons/react/16/solid"; 
import config from "../config.js";
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { PageInfo } from "../components/page-info";  
import { Loader } from "../components/loader";
import { Button } from "../components/button";
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '../components/description-list'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/table";
import { Field } from "../components/fieldset";
import CycleStatusView from './CycleStatusView';
import CycleStatusViewQC from './CycleStatusViewQC';
import { useSession } from '../components/session-provider';
import InfoPopup from "../components/InfoPopup";
//
export default function ViewCycle() {
  const [initialData, setInitialData] = useState(null);
  const [optionsAI, setOptionsAI] = useState([]);
  const [loadInfo, setLoadInfo] = useState('');
  const [emphasisOpt, setEmphasisOpt] = useState([]);
  const toTitleCase = (str) => {
		  if (!str) return "";  
		  return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
		}; 
  const getMatchedAI = (rules = []) => {
	  return rules.map(rule => {
		const cleanRule = rule.replace(/^Predefined:/i, '').trim();
		const match = optionsAI.find(opt => opt.ai_instruction === cleanRule);
		const text =  match?.ai_key || cleanRule;  
		return text.replace(/custom:/gi, '').trim();
	  });
	};
  const { cycleId } = useParams();   
  const pageTitle = 'View';
  const { session } = useSession();
  const currentCompany = session?.company ?? ""; 	
  var breadcrumbsLink  = [
    { name: currentCompany, href: "/title-test", current: false },
    { name: `${pageTitle} a Title Test`, href: "#", current: true },
  ]; 
  //
  const navigate  = useNavigate();
  let page_info = `This section allows you to view an existing Title Test and explore different title variations.`; 
  //On Focus Process Variables  
  const effectRan = useRef(false); 
  //Define Variables
  const [loading, setLoading] = useState(false);  
  useEffect(() => {  
	  if (!effectRan.current) {
        effectRan.current = true;
		if(cycleId !=='' && cycleId !== undefined) {
		  setLoading(true);
		  fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_instruct`,
          {
            method: "GET",
            credentials: "include",
          }
          )
          .then((res) => res.json())
          .then((data) => {
            if (
              data.status === "error" &&
              data.errMsg === "Invalid Loign Data"
            ) {
              window.location.href = `/${config.appPath}`;
            } else {
              setOptionsAI(data);
            }
          });
			
		  fetch(`${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=view_cycle&cycle_master_id=${cycleId}`,{
            method: "GET",
            credentials: "include",
          }
          )
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
              window.location.href = `/${config.appPath}`;
            } else {  
			  if (data.records && typeof data.records === 'object' && Object.keys(data.records).length > 0) { 
				setInitialData(data.records); 
				setLoading(false);
              } else {
				navigate('/title-test');
			  }
            }
          }); 
		} 
	  } 
	  getEmphasisData();
	  getPerformanceData(cycleId);
  }, []); 
	  
  const getPerformanceData = async (id) => {
    try {
      setLoading(true);

      // Make the API call
      const response = await fetch(
        `${config.apiPath}performance_process/performance_status_api.php`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cycle_id : id }),
        }
      ); 
      // Parse the response
      const data = await response.json(); 
      // If the API call is successful, assign the data to one field
      if (data.status === "error" && data.errMsg === "Invalid Loign Data"  ) {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === 'success') {
        setLoadInfo(data.load_info);
      }  
    } catch (error) {
      alert("Failed to fetch adwords data", "", "error", 3000);
    } finally {
      setLoading(false);
    }
  };
  const getEmphasisData = async () => {
    try {
      setLoading(true); 
      // Make the API call
      const response = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_default_emphasis`,
        {
          method: 'GET',
          credentials: 'include' 
        }
      ); 
      // Parse the response
      const data = await response.json(); 
      // If the API call is successful, assign the data to one field
      if (data.status === "error" && data.errMsg === "Invalid Loign Data"  ) {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === true) {
        setEmphasisOpt(data.emphasisList); 
      }  
    } catch (error) {
      alert("Failed to fetch adwords data", "", "error", 3000);
    } finally {
      setLoading(false);
    }
  }; 
  const getEmphasisLabel = (category, emphasisValue) => {
    const match = emphasisOpt.find(opt => opt.category === category);
    if (!match || !match.emphasis) return "NA";

    // Find the key whose value matches the emphasisValue
    const foundKey = Object.entries(match.emphasis).find(
      ([key, value]) => value === emphasisValue
    );

    return foundKey ? foundKey[0] : "NA"; // Return the value again or return the key (foundKey[0]) if needed
  };
	  
  const titleDepthOpt = [
    { value: "use_shopping_only", label: "Use data in Google Shopping only" },
    { value: "think_carefully", label: "Think carefully to improve data (uses more tokens)" },
	{ value: "think_deeply", label: "Think deeply to improve data (uses even more tokens)" },
  ]; 
  const getAPILabel = (value) => {
	  const match = titleDepthOpt.find(opt => opt.value === value);
	  return match?.label || "NA";
  };
	  
  const getBadgeColor = (emphasis) => {
		  switch (emphasis) {
			case 'Brand':
			  return 'red';
			case 'Size':
			  return 'lime';
			case 'Colour':
			  return 'green';
			case 'Gender':
			  return 'sky';
			case 'Pattern':
			  return 'purple';
			case 'Material':
			  return 'pink';
			case 'Sale Feature':
			  return 'indigo';
			default:
			  return 'zinc'; // fallback color
		  }
  };
	
   return (
    <Fragment>
      <SidebarLayoutNew selected_menu="title-test"> 
        <BreadcrumbsNew pages={breadcrumbsLink} />
	        <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
           <EyeIcon  className="!size-8" />
          <Heading>{toTitleCase(initialData && initialData.cycle_name && initialData.cycle_name)} </Heading> 
          <Badge color="lime">{initialData?.cycle_status || "In Progress"}</Badge>
          <div className="flex items-center gap-2 ml-auto">
          <Button className="flex items-center gap-1" onClick={() => navigate("/title-test")}>
                Back
              </Button>
            </div>
        </div>
        <PageInfo info={page_info} /> 
		    {initialData?.qcTest === true ?  
          <CycleStatusViewQC cycleId ={cycleId} loadInfo={loadInfo}  /> : 
          <CycleStatusView cycleId ={cycleId} loadInfo={loadInfo}  />}

			<div className="flex gap-4 transition-all duration-500 mt-8">
		    <div class="flex-[4] rounded-2xl border shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] hover:[grid-column:span_2] hover:w-full">
        <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>Summary of Test Title</Subheading>
          </div>
           <div class="p-4 sm:p-6 !pt-2 dark:border-gray-800">
          <DescriptionList>
            <DescriptionTerm>Test Name</DescriptionTerm>
            <DescriptionDetails>
            <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
              {initialData && initialData.cycle_name && initialData.cycle_name}
            </div>
              </DescriptionDetails> 
            <DescriptionTerm>Test Objective</DescriptionTerm>
            <DescriptionDetails>
              <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
                {initialData && initialData.cycle_objective && initialData.cycle_objective}
              </div>
              </DescriptionDetails> 
          </DescriptionList>
          </div>
        </div>
		
       <div class="flex-[6] rounded-2xl border shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] hover:[grid-column:span_2] hover:w-full">
       <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>Select Products</Subheading>
         </div>
         <div className="w-full p-4 sm:p-6 !pt-2 dark:border-gray-800">
		   <DescriptionList className='w-full !grid-cols-1'>
          <div className="grid grid-cols-2 gap-6">
            <div className="grid grid-cols-[40%_60%] gap-2">
              <DescriptionTerm>Category</DescriptionTerm>
              <DescriptionDetails>
                <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
                {toTitleCase(initialData?.category === 'all'? 'All Category': initialData?.fullPath ?? 'NA')}
                </div>
                </DescriptionDetails>
            </div>
            <div className="grid grid-cols-[40%_60%] gap-2">
              <DescriptionTerm>Brand</DescriptionTerm>
              <DescriptionDetails>
                <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
                {toTitleCase(initialData?.brand === 'all'? 'All Brand': initialData?.brand ?? 'NA')}
                </div>
                </DescriptionDetails>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="grid grid-cols-[40%_60%] gap-2">
			        <DescriptionTerm>Impressions</DescriptionTerm>
            <DescriptionDetails>
              <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
              {toTitleCase(initialData?.impressions === 'all'? 'All Impression': `Less than ${initialData?.impressions}` ?? 'NA')}
              </div>
              </DescriptionDetails> 
            </div>
            <div className="grid grid-cols-[40%_60%] gap-2">
			        <DescriptionTerm>Sku Limit</DescriptionTerm>
              <DescriptionDetails>
                <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
                {toTitleCase(initialData?.sku_limit ?? '50')}
                </div>
              </DescriptionDetails> 
            </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="grid grid-cols-[40%_60%] gap-2">
                <DescriptionTerm>Product Selection Mode <InfoPopup message={{
    title: "Product Selection Mode",
    body: "Choose whether to include all active products, or exclude products already used in another cycle."
  }} /> </DescriptionTerm>
                <DescriptionDetails>
                  <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10">
                  {toTitleCase(initialData?.batch_type === 'include_all'? 'Include All Products': 'Exclude Exist Cycle Products')}
                  </div>
                </DescriptionDetails>
              </div>
            </div>
          </DescriptionList>
          </div>
		</div>
</div>
		<div class="rounded-2xl border mt-4 shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>API Type</Subheading>
      </div>
			<div class="p-4 sm:p-6 !pt-2 dark:border-gray-800">
		    <DescriptionList>
              <DescriptionTerm className="flex items-center  whitespace-nowrap">Title Depth
<InfoPopup
  message={{
    title: "Title Depth",
    body: (
      <div className="space-y-3 text-x-sm">
        <div>
          <span className="font-semibold">1. Use data in Google Shopping only</span><br />
          <span className="text-gray-700">Generates a title using only the details you provide.</span>
        </div>

        <div>
          <span className="font-semibold">2. Think carefully to improve data</span><br />
          <span className="text-gray-700">Adds AI-suggested product attributes for a richer, descriptive title.</span>
        </div>

        <div>
          <span className="font-semibold">3. Think deeply to improve data</span><br />
          <span className="text-gray-700">Adds AI-suggested attributes and keywords for SEO-optimized titles.</span>
        </div>
      </div>
    )
  }}
/>
</DescriptionTerm>
              <DescriptionDetails>
                <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit">
                {getAPILabel(initialData?.title_depth)}
                </div>  
              </DescriptionDetails>
                
            </DescriptionList>
        </div>
	   </div>

		<div class="rounded-2xl border mt-4 shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>Title Permutations</Subheading>
    </div>
    <div class="p-4 sm:p-6 !pt-2 dark:border-gray-800">
			 {initialData?.permutations &&
			  Object.entries(initialData.permutations).map(([key, value]) => {
				const label = getEmphasisLabel(value?.category, value?.emphasis);
				return ( <div key={key} class="rounded-2xl border mt-4 shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"><div class="dark:border-gray-800">
					  <div className="grid grid-cols-1 md:grid-cols-[35%_65%] gap-2">
			<div className="space-y-8 border-r border-gray-300 p-4">
				  <header className="mb-2">
					
            <div className="rounded-md text-sm font-semibold bg-blue-100 px-3 py-1 text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit mb-2">
					  {toTitleCase(value?.title || 'Untitled')}
            </div>
			        <p className="text-sm text-gray-600 mb-3">
					  <span className="font-medium"> <strong className="font-semibold">Category:</strong></span>{" "}
					   {value?.category}
					</p>
					<p className="text-sm text-gray-600 mb-3">
					  <span className="font-medium"><strong className="font-semibold">Emphasis:</strong></span>{" "}
					  <Badge color={getBadgeColor(label)}>
						  {label}
					  </Badge>
					</p>

<p className="text-sm text-gray-600 mb-3">
					  <span className="font-medium">
<strong className="font-semibold">Apply default title policies:</strong>

<InfoPopup
  message={{
    title: "Apply Default Title Policies",
    body: (
      <div className="space-y-4 text-x-sm">

        {/* YES */}
        <div className="flex items-start gap-2">
          <span className="text-blue-500 font-bold text-lg">✔</span>
          <div>
            <div className="font-semibold text-gray-900">Yes - Apply Default System Rules</div>
            <div className="text-gray-700 mt-1">
              Uses the platform’s built-in title guidelines and automatically runs the Title API.
            </div>
          </div>
        </div>

        {/* NO */}
        <div className="flex items-start gap-2">
          <span className="text-red-500 font-bold text-lg">✖</span>
          <div>
            <div className="font-semibold text-gray-900">No - Do Not Apply Rules</div>
            <div className="text-gray-700 mt-1">
              Skips all default rules and runs the Title API using only your selected <strong>Emphasis</strong>.
            </div>
          </div>
        </div>

        {/* CUSTOM */}
        <div className="flex items-start gap-2">
          <span className="text-yellow-500 font-bold text-lg">⚙</span>
          <div>
            <div className="font-semibold text-gray-900">Choose Which Apply</div>
            <div className="text-gray-700 mt-1">
              Lets you modify or override the default rules and apply your own custom rule set before running the Title API.
            </div>
          </div>
        </div>

      </div>
    )
  }}
/> 
</span>{" "}
					   {value?.default_policy === "choose"
  ? "Choose which apply"
  : toTitleCase(value?.default_policy)}
					</p>

				  </header>
					

				  <div className="text-sm text-gray-600 mb-2 font-medium"><strong className="font-semibold">Rules:</strong></div>
				  <div className="max-h-40 overflow-y-auto">		   	
				  {value?.rules && value.rules.length > 0 ? ( 
					<ul className="list-disc list-inside text-sm text-gray-700 space-y-1"> 
					  {getMatchedAI(value.rules).map((aiKey, index) => (
						<li key={index}>{toTitleCase(aiKey)}</li>
					  ))}
					</ul>
				  ) : (
					<p className="text-sm text-gray-500">No rules defined.</p>
				  )}
				 </div>
			</div>
			<div className="p-4">
			 <Field>
            <Subheading className="mb-2">Examples</Subheading>
            <div className="max-h-60 overflow-y-auto">
              <Table className="mb-2 !overflow-x-visible">
                <TableHead className="sticky top-0 bg-white z-10 text-[13px]">
                  <TableRow>
                    <TableHeader>Product Image</TableHeader>
                    <TableHeader>Name</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={3} className="py-6">
                        <Loader />
                      </TableCell>
                    </TableRow>
                  ) : Array.isArray(value?.ai_results) && value?.ai_results.length > 0 ? (
                    value.ai_results.map((item, idx) => (
                      <TableRow key={idx} className="text-[13px]">
                        <TableCell className="!p-2">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="h-[100px] w-[100px] object-cover rounded"
                          />
                        </TableCell>
                        <TableCell className="!p-2 break-words whitespace-normal">
                          <div className="block">
                            <span className="font-semibold">Source Title:</span>{" "}
                            <a
                              className="text-indigo-600 hover:text-indigo-900 dark:text-indigo-400 dark:hover:text-indigo-300 cursor-pointer"
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.name}
                            </a>
                          </div>
                          <div className="block mt-1">
                            <span className="font-semibold">AI Title:</span>{" "}
                            {item.aiName}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        className="py-6 text-center text-gray-500"
                      >
                        No products selected.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>{" "}
            </div>
          </Field> </div></div>
				</div></div>);
			  })}
        </div>
		</div> 
    <div className="flex gap-4 transition-all duration-500">
		<div class="flex-1 rounded-2xl border mt-4 shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>Trigger</Subheading>
      </div>
      <div class="p-4 sm:p-6 !pt-2 dark:border-gray-800">
		  <DescriptionList> 
		  {initialData && initialData.impression_count && initialData.impression_count !== "" && (
		    <><DescriptionTerm>Impressions</DescriptionTerm>
            <DescriptionDetails>
              <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit">
              {initialData && initialData.impression_count && initialData.impression_count}
              </div>
            </DescriptionDetails> </>
		  )}
		  {initialData && initialData.days && initialData.days !== "" && (
		    <><DescriptionTerm>Days</DescriptionTerm>
            <DescriptionDetails>
              <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit">
              {initialData && initialData.days && initialData.days}
              </div>
            </DescriptionDetails> </>
		  )}
		  </DescriptionList>
      </div>
		</div>

		<div class="flex-1 rounded-2xl border mt-4 shadow-[0_0_15px_rgba(0,0,0,0.12)] border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
          <Subheading>When to start</Subheading>
          </div>
      <div class="p-4 sm:p-6 !pt-2 dark:border-gray-800">
		  <DescriptionList>
		  <DescriptionTerm>QC Before Test Goes Live</DescriptionTerm>
          <DescriptionDetails>
            <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit">
            {initialData?.qcTest === true ? "Yes" : "No"}
            </div>
          </DescriptionDetails>
		  <DescriptionTerm>Cycle Start After</DescriptionTerm>
          <DescriptionDetails>
            <div className="rounded-md bg-blue-100 px-2 py-1.5 text-xs font-medium text-blue-700 ring-1 ring-blue-600/20 ring-inset dark:bg-blue-500/10 dark:text-blue-500 dark:ring-blue-500/10 w-fit">
          {initialData && initialData.custom_date && (() => {
							  const date = new Date(initialData.custom_date);
							  const day = String(date.getDate()).padStart(2, '0');
							  const month = String(date.getMonth() + 1).padStart(2, '0');
							  const year = date.getFullYear();
							  return `${day}-${month}-${year}`;
							})()}
            </div>
          </DescriptionDetails>   
		  </DescriptionList>
      </div>
		</div>
		 </div>
      <div className="flex justify-end gap-4 mt-4">
        <Button type="reset" onClick={() => navigate("/title-test")}>
          Back
        </Button>
      </div>
	    
		 {loading && <Loader />}
      </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
	   
	
}